import { Directive, HostListener, ElementRef,Input } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormGroup } from '@angular/forms';

@Directive({
  exportAs: 'MultiEmailValidationDirective',
  selector: 'MultiEmailValidationDirective, [MultiEmailValidationDirective]'    
})
export class MultiEmailValidationDirectiveDirective{
 @Input() directiveControl: string;
  errorMessage: string;
  emailValueControl;
  error: boolean;
  control: UntypedFormGroup;
  constructor(private el: ElementRef, private _fg: ControlContainer) {
    this.errorMessage = "";
    this.emailValueControl = this.el.nativeElement;
    this.error = false;   
    this.control = (this._fg.formDirective as FormGroupDirective).form;
    let existingformError = {valid: this.control.getError('valid')};    
    this.control.setErrors(existingformError);  
  }

  @HostListener('click')
  

  @HostListener('blur')
  emailValidation() {
    let emailValue: string = this.emailValueControl.value; // Read the values containing emails seperated by ','
    if (emailValue.trim()!= "") {
      let emailsArray: string[] = emailValue.split(','); // Split it based on the special charecter ','      
      emailsArray.forEach(email => { // Loop through it and validate each email              
        this.error = false;        
        if (!validateEmail(email)) {
          //return "Error in email address:"+email;    
          this.errorMessage = 'Spaces or Enter not allowed between two email or Email Value you have entered ' + email + ' is in-appropriate';                                       
          this.error = true;
          this.control.setErrors({valid:false});
          return false;
        }
      });
      //this.control.setErrors(null);
    }
    else {
      this.error = false;
      this.errorMessage="";
      this.el.nativeElement.value=""; //With this you can display the place holder message again even if there arre more spaces in teh text entered
    }
    
    if(!this.error){
      this.control.setErrors(null);       
    }

    function validateEmail(email: string) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
        
  }

}
